import { Row, Col, Button, notification, Tabs, Checkbox, message } from "antd";
import CustomLabelValue from "pages/components/CustomLabelValue";
import {
  HistoryOutlined,
  UnorderedListOutlined,
  SyncOutlined,
  ImportOutlined,
  ExperimentOutlined,
} from "@ant-design/icons";
import ImportDataPig from "pages/PigFarm/ListPigFarm/importDataPig";
import { ModalInfoType, PayloadType } from "type";
import { useDispatch } from "react-redux";
import { setModal } from "features/modalSlice";
import _ from "lodash";
import queryString from "query-string";
import { memo, useEffect, useRef, useState } from "react";
import { getStatisticals } from "features/statisticalSlice";

import TabPig from "./TabPig";
import ReworkSynthe from "./ReworkSynthe";
import { updateHerd } from "features/herdSlice";
import { POST } from "services/ServiceBase";
import ServiceURL from "services/ServiceURL";
import { stringifyQuery } from "utils";
function tabContent(data: any) {
  const dataHerd = _.get(data, "record", {});
  const [isDemo, setIsDemo] = useState<boolean>(
    _.get(dataHerd, "isDemo", false)
  );
  const typeOfHerd = _.get(data, "record.typeId.code", "");
  const dataTabList = [
    {
      label: "Danh sách lợn trong trại",
      key: "LIST",
    },
    {
      label: "Lịch sử",
      key: "HISTORY",
    },
  ];

  const dataTabListTTT = [
    {
      label: "Danh sách lợn trong trại",
      key: "LIST",
    },
  ];

  const handleChangeTabList = (key: string) => {
    setKeyTabList(key);
  };

  const [keyTabList, setKeyTabList] = useState<any>("LIST");
  const dataActiverHerd = _.get(data, "dataActiverHerd", {});
  const [dataPigs, setDataPigs] = useState<any>({});
  const dispatch = useDispatch();

  // call api lấy thông tin về lợn của trại
  function handleGetHerdByUserId(herdId: any) {
    const payload: PayloadType = {
      query: queryString.stringify(
        {
          herdId: herdId,
        },
        {
          skipNull: true,
          skipEmptyString: true,
        }
      ),
      skipUpdateReducer: false,
      callback: {
        success(herds) {
          setDataPigs(herds?.result);
        },
        failed(errorMessage) {
          notification.error({
            message: "Có lỗi xảy ra trong quá trình lấy danh sách!",
            description: errorMessage,
          });
        },
      },
    };
    dispatch(getStatisticals(payload));
  }

  useEffect(() => {
    handleGetHerdByUserId(dataHerd.id);
  }, []);
  const [productTypeCode, setProductTypeCode] = useState<string>("");

  const fileInputRef = useRef<HTMLInputElement>(null);
  const fileInputRef1 = useRef<HTMLInputElement>(null);
  const fileInputRef2 = useRef<HTMLInputElement>(null);
  const fileInputRef3 = useRef<HTMLInputElement>(null);
  const fileInputRef4 = useRef<HTMLInputElement>(null);
  const fileInputRef5 = useRef<HTMLInputElement>(null);

  const handleButtonClick = (type: string) => {
    setProductTypeCode(type);
    fileInputRef.current?.click();
  };

  interface FileChangeEvent extends React.ChangeEvent<HTMLInputElement> {
    target: HTMLInputElement & EventTarget;
  }

  interface UploadResponse {
    data: any;
  }

  const handleFileChange = async (event: FileChangeEvent): Promise<void> => {
    const file: File | undefined = event.target.files?.[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file); // 'file' là key được backend chấp nhận

    try {
      await POST(
        `${ServiceURL.products}/importExcel?${stringifyQuery({
          productTypeCode: productTypeCode,
          herdId: _.get(dataHerd, "id", ""),
        })}`,
        formData
      );

      message.success("Upload thành công!");
    } catch (error: any) {
      const errorMsg: string =
        error?.response?.data?.message || error.message || "Đã xảy ra lỗi";
      message.error(`Upload thất bại: ${errorMsg}`);
    } finally {
      event.target.value = "";
    }
  };
  const handleImportQuyTrinhTiemChoLon = async (
    event: FileChangeEvent
  ): Promise<void> => {
    console.log("event");
    const file: File | undefined = event.target.files?.[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file); // 'file' là key được backend chấp nhận

    try {
      await POST(
        `${
          ServiceURL.pigs
        }/guest/importGuestAppliedActionConfigIds?${stringifyQuery({
          herdId: _.get(dataHerd, "id", ""),
        })}`,
        formData
      );

      message.success("Upload thành công!");
    } catch (error: any) {
      const errorMsg: string =
        error?.response?.data?.message || error.message || "Đã xảy ra lỗi";
      message.error(`Upload thất bại: ${errorMsg}`);
    } finally {
      event.target.value = "";
    }
  };

  const handleImportQuyTrinhTiemChoChuong = async (
    event: FileChangeEvent
  ): Promise<void> => {
    console.log("event");
    const file: File | undefined = event.target.files?.[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file); // 'file' là key được backend chấp nhận

    try {
      await POST(
        `${
          ServiceURL.actions
        }/importGuestAppliedActionConfigIds?${stringifyQuery({
          herdId: _.get(dataHerd, "id", ""),
        })}`,
        formData
      );

      message.success("Upload thành công!");
    } catch (error: any) {
      const errorMsg: string =
        error?.response?.data?.message || error.message || "Đã xảy ra lỗi";
      message.error(`Upload thất bại: ${errorMsg}`);
    } finally {
      event.target.value = "";
    }
  };

  const handleImportLichSuTiemChoChuong = async (
    event: FileChangeEvent
  ): Promise<void> => {
    console.log("event");
    const file: File | undefined = event.target.files?.[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file); // 'file' là key được backend chấp nhận

    try {
      await POST(
        `plans/guest/importVacxinBarn?${stringifyQuery({
          herdId: _.get(dataHerd, "id", ""),
        })}`,
        formData
      );

      message.success("Upload thành công!");
    } catch (error: any) {
      const errorMsg: string =
        error?.response?.data?.message || error.message || "Đã xảy ra lỗi";
      message.error(`Upload thất bại: ${errorMsg}`);
    } finally {
      event.target.value = "";
    }
  };

  const handleImportLichSuTiemChoLon = async (
    event: FileChangeEvent
  ): Promise<void> => {
    console.log("event");
    const file: File | undefined = event.target.files?.[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file); // 'file' là key được backend chấp nhận

    try {
      await POST(
        `plans/guest/importVacxinPig?${stringifyQuery({
          herdId: _.get(dataHerd, "id", ""),
        })}`,
        formData
      );

      message.success("Upload thành công!");
    } catch (error: any) {
      const errorMsg: string =
        error?.response?.data?.message || error.message || "Đã xảy ra lỗi";
      message.error(`Upload thất bại: ${errorMsg}`);
    } finally {
      event.target.value = "";
    }
  };
  const handleImportLichSuTiemChoLonConTheoMe = async (
    event: FileChangeEvent
  ): Promise<void> => {
    console.log("event");
    const file: File | undefined = event.target.files?.[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file); // 'file' là key được backend chấp nhận

    try {
      await POST(
        `plans/guest/importVacxinPig?${stringifyQuery({
          herdId: _.get(dataHerd, "id", ""),
          isLctm: true,
        })}`,
        formData
      );

      message.success("Upload thành công!");
    } catch (error: any) {
      const errorMsg: string =
        error?.response?.data?.message || error.message || "Đã xảy ra lỗi";
      message.error(`Upload thất bại: ${errorMsg}`);
    } finally {
      event.target.value = "";
    }
  };

  return (
    <>
      <Row
        id="2"
        style={{
          paddingTop: 16,
          paddingLeft: 20,
          paddingRight: 20,
          background: "rgba(242, 242, 242, 0.50)",
        }}
      >
        <Col span={12}>
          <CustomLabelValue
            hasMarginleft={false}
            alignX={120}
            label="Mã trang trại"
            value={_.get(dataHerd, "code", "")}
          />
          <CustomLabelValue
            hasMarginleft={false}
            alignX={120}
            label="Tên trang trại "
            value={_.get(dataHerd, "name", "")}
          />

          <CustomLabelValue
            hasMarginleft={false}
            alignX={120}
            label="Loại trang trại"
            value={_.get(dataHerd, "typeId.name", "")}
          />
          <CustomLabelValue
            hasMarginleft={false}
            alignX={120}
            colorStatus={_.get(dataActiverHerd, "status", "")}
            label="Trạng thái: "
            value={
              _.get(dataActiverHerd, "status", "") === "active"
                ? "Đang hoạt động"
                : "Đóng"
            }
          />

          <Checkbox
            style={{
              marginBottom: "16px",
              fontWeight: "bold",
            }}
            checked={isDemo}
            onChange={(e) => {
              setIsDemo(e.target.checked);
              const payload: PayloadType = {
                params: dataHerd.id,
                body: {
                  isDemo: e.target.checked,
                },
                callback: {
                  success() {
                    notification.success({
                      message: "Cập nhật thành công!",
                    });
                  },
                  failed(errorMessage) {
                    notification.error({
                      message: "Có lỗi xảy ra trong quá trình cập nhật!",
                      description: errorMessage,
                    });
                  },
                },
              };
              dispatch(updateHerd(payload));
            }}
          >
            Là trại mẫu
          </Checkbox>
        </Col>
        <Col span={12}>
          <CustomLabelValue
            hasMarginleft={false}
            alignX={120}
            label="Tổng đàn"
            value={
              _.get(dataPigs, "TONG_NAI", []) +
              " Nái; " +
              _.get(dataPigs, "TONG_DUC", []) +
              " Đực; " +
              _.get(dataPigs, "TONG_CON", []) +
              " Lợn con; " +
              _.get(dataPigs, "TONG_THIT", []) +
              " Thịt"
            }
          />
          <CustomLabelValue
            hasMarginleft={false}
            alignX={120}
            label="Số chuồng: "
            value={_.get(dataHerd, "childrent", []).length}
          />

          <CustomLabelValue
            hasMarginleft={false}
            alignX={120}
            label="Địa chỉ hiện tại"
            value={_.get(dataActiverHerd, "address", "")}
          />
          {_.get(dataActiverHerd, "status", "") === "active" ? (
            <Row>
              <Col
                lg={4}
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <div style={{ fontWeight: "bold " }}>Cập nhật dữ liệu:</div>
              </Col>
              <Col lg={20}>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                  <Button
                    type="primary"
                    onClick={() => {
                      const payload: ModalInfoType = {
                        open: true,
                        title: "Nhập danh sách lợn",
                        content: (
                          <ImportDataPig data={data} type={"ImportPig"} />
                        ),
                        dataUpdate: "",
                        size: 350,
                      };
                      dispatch(setModal(payload));
                    }}
                  >
                    <UnorderedListOutlined />
                    &nbsp;Nhập DS lợn
                  </Button>
                  <Button
                    type="primary"
                    onClick={() => {
                      const payload: ModalInfoType = {
                        open: true,
                        title: "Nhập lịch sử lợn",
                        content: (
                          <ImportDataPig data={data} type={"ImportHistory"} />
                        ),
                        dataUpdate: "",
                        size: 350,
                      };
                      dispatch(setModal(payload));
                    }}
                  >
                    <HistoryOutlined />
                    &nbsp;Nhập lịch sử lợn
                  </Button>
                  <Button
                    type="primary"
                    onClick={() => {
                      const payload: ModalInfoType = {
                        open: true,
                        title: "Chọn ngày chạy lại",
                        content: (
                          <ReworkSynthe data={{ herdId: dataHerd.id }} />
                        ),
                        dataUpdate: "",
                        size: 350,
                      };
                      dispatch(setModal(payload));
                    }}
                  >
                    <SyncOutlined />
                    &nbsp;Chạy lại thống kê tổng hợp
                  </Button>
                  {dataHerd.typeId.code !== "TTT" ? (
                    <div>
                      <input
                        type="file"
                        ref={fileInputRef1}
                        style={{ display: "none" }}
                        onChange={handleImportQuyTrinhTiemChoLon}
                        accept=".xlsx,.xls,.csv"
                      />
                      <Button
                        icon={<ImportOutlined />}
                        type="primary"
                        onClick={() => fileInputRef1.current?.click()}
                      >
                        Nhập quy trình tiêm cho lợn
                      </Button>
                    </div>
                  ) : (
                    ""
                  )}
                  <div>
                    <input
                      type="file"
                      ref={fileInputRef2}
                      style={{ display: "none" }}
                      onChange={handleImportQuyTrinhTiemChoChuong}
                      accept=".xlsx,.xls,.csv"
                    />
                    <Button
                      icon={<ImportOutlined />}
                      type="primary"
                      onClick={() => fileInputRef2.current?.click()}
                    >
                      Nhập quy trình tiêm cho chuồng
                    </Button>
                  </div>{" "}
                  <div>
                    <input
                      type="file"
                      ref={fileInputRef}
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                      accept=".xlsx,.xls,.csv"
                    />
                    <Button
                      icon={<ExperimentOutlined />}
                      type="primary"
                      onClick={() => handleButtonClick("MEDICINE_TYPE")}
                    >
                      Nhập danh sách thuốc
                    </Button>
                  </div>
                  <div>
                    <Button
                      icon={<ImportOutlined />}
                      type="primary"
                      onClick={() => handleButtonClick("FOOD_TYPE")}
                    >
                      Nhập danh sách thức ăn
                    </Button>
                  </div>
                  <div>
                    <input
                      type="file"
                      ref={fileInputRef4}
                      style={{ display: "none" }}
                      onChange={handleImportLichSuTiemChoChuong}
                      accept=".xlsx,.xls,.csv"
                    />
                    <Button
                      icon={<ImportOutlined />}
                      type="primary"
                      onClick={() => fileInputRef4.current?.click()}
                    >
                      Nhập lịch sử tiêm cho chuồng
                    </Button>
                  </div>{" "}
                  {dataHerd.typeId.code !== "TTT" ? (
                    <div>
                      <input
                        type="file"
                        ref={fileInputRef3}
                        style={{ display: "none" }}
                        onChange={handleImportLichSuTiemChoLon}
                        accept=".xlsx,.xls,.csv"
                      />
                      <Button
                        icon={<ImportOutlined />}
                        type="primary"
                        onClick={() => fileInputRef3.current?.click()}
                      >
                        Nhập lịch sử tiêm cho lợn
                      </Button>
                    </div>
                  ) : (
                    ""
                  )}
                  {dataHerd.typeId.code !== "TTT" ? (
                    <div>
                      <input
                        type="file"
                        ref={fileInputRef5}
                        style={{ display: "none" }}
                        onChange={handleImportLichSuTiemChoLonConTheoMe}
                        accept=".xlsx,.xls,.csv"
                      />
                      <Button
                        icon={<ImportOutlined />}
                        type="primary"
                        onClick={() => fileInputRef5.current?.click()}
                      >
                        Nhập lịch sử tiêm cho lợn con theo mẹ
                      </Button>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </Col>
            </Row>
          ) : (
            ""
          )}
        </Col>
      </Row>
      <div>
        <Tabs
          onChange={handleChangeTabList}
          defaultActiveKey={`${keyTabList}`}
          items={typeOfHerd === "TTT" ? dataTabListTTT : dataTabList}
        />
        <TabPig
          typeOfHerd={typeOfHerd}
          data={data}
          keyTabList={keyTabList}
          setKeyTabList={setKeyTabList}
        />
      </div>
    </>
  );
}

export default memo(tabContent);
